export default "__VITE_ASSET__CD1wOr8W__"